'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const tslib = require('tslib');
const valueTypes = require('../dom/utils/value-types.js');
const transform = require('../html/utils/transform.js');
const index = require('../index.js');
const buildAttrs = require('./utils/build-attrs.js');
const scrapeMotionValues = require('./utils/scrape-motion-values.js');
const visualElement = require('../html/visual-element.js');
const camelToDash = require('../dom/utils/camel-to-dash.js');
const camelCaseAttrs = require('./utils/camel-case-attrs.js');

function renderSVG(element, renderState) {
  visualElement.htmlConfig.render(element, renderState);
  for (var key in renderState.attrs) {
    element.setAttribute(!camelCaseAttrs.camelCaseAttributes.has(key) ? camelToDash.camelToDash(key) : key, renderState.attrs[key]);
  }
}
var svgVisualElement = index.visualElement(tslib.__assign(tslib.__assign({}, visualElement.htmlConfig), {
  getBaseTarget: function (props, key) {
    return props[key];
  },
  readValueFromInstance: function (domElement, key) {
    var _a;
    if (transform.isTransformProp(key)) {
      return ((_a = valueTypes.getDefaultValueType(key)) === null || _a === void 0 ? void 0 : _a.default) || 0;
    }
    key = !camelCaseAttrs.camelCaseAttributes.has(key) ? camelToDash.camelToDash(key) : key;
    return domElement.getAttribute(key);
  },
  scrapeMotionValuesFromProps: scrapeMotionValues.scrapeMotionValuesFromProps,
  build: function (_element, renderState, latestValues, projection, layoutState, options, props) {
    buildAttrs.buildSVGAttrs(renderState, latestValues, projection, layoutState, options, props.transformTemplate);
  },
  render: renderSVG
}));

exports.renderSVG = renderSVG;
exports.svgVisualElement = svgVisualElement;
